import React from 'react';
import './Header.css'
import logo from '../../images/logo.png'
import { Link, NavLink } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const Header = () => {

    const { user, signOutUser } = useAuth()

    return (
        user && <nav className="navbar navbar-expand-md">
            <div className="container">
                <Link className="navbar-brand" to="/dashboard">
                    <img width='200px' src={logo} alt="" />
                </Link>


                <div className='d-flex  align-items-center'>
                    <button className="navbar-toggler shadow-none mt-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"><i className="fas fa-bars"></i></span>
                    </button>
                </div>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                        <li className="nav-item">
                            <NavLink style={({ isActive }) => {
                                return {
                                    color: isActive ? "#9B00E5" : ""
                                };
                            }} className="nav-link" aria-current="page" to="/dashboard">Home</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink style={({ isActive }) => {
                                return {
                                    color: isActive ? "#9B00E5" : ""
                                };
                            }} className="nav-link" aria-current="page" to="/add-service">Add Service</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink onClick={() => signOutUser()} className="nav-link" aria-current="page" to="">Sign Out</NavLink>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;